<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import uploadFile from "@/views/components/common/form/uploadFile.vue";
import { Input, Row, Col, ButtonGroup, Button } from "view-design";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "regard",
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "标题",
          name: "title",
          value: "",
          type: "input",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "语音文件",
          name: "content",
          value: "",
          type: "audio",
        },
        // {
        //   label: "技术分类",
        //   name: "category_id",
        //   value: "1",
        //   type: "select",
        //   dropList: [],
        //   onChange: this.onSelect,
        // },
        // {
        //   label: "用户标签",
        //   name: "tag_ids",
        //   value: "",
        //   type: "select",
        //   multiple: true,
        //   dropList: [],
        // },
        // {
        //   label: "图片",
        //   name: "image",
        //   value: "",
        //   type: "image",
        //   desc: "图片尺寸最低750*462像素",
        //   rules: [{ required: true, trigger: "blur" }],
        // },
        // {
        //   label: "简介",
        //   name: "content",
        //   value: "",
        //   type: "textarea",
        //   maxlength: 500,
        //   rules: [{ type: "string", max: 500, message: "超过最大长度" }],
        // },
        // {
        //   label: "视频",
        //   name: "video",
        //   value: "",
        //   type: "video",
        //   rules: [{ required: false, trigger: "blur" }],
        // },
        // {
        //   label: "标签",
        //   name: "tag",
        //   value: "",
        //   type: "textarea",
        //   maxlength: 500,
        //   rules: [{ type: "string", max: 500, message: "超过最大长度" }],
        //   desc:"回车换行"
        // },
        { label: '详情', name: 'detail', value: '', type: 'editor' },
        // {
        //   label: "是否可评论",
        //   name: "is_open_comment",
        //   value: 1,
        //   type: "switch",
        //   trueValue: 1,
        //   falseValue: 0,
        // },
        // {
        //   label: "是否展示",
        //   name: "status",
        //   value: 1,
        //   type: "switch",
        //   trueValue: 1,
        //   falseValue: 0,
        // },
      ],
      forms: {},
    };
  },
  created() {
    // this.loadLevelData();
    // this.gettagsDrop();
  },
  methods: {
    // loadLevelData() {
    //   let q = {
    //     model: "skill",
    //   };
    //   $utils.api.load(`categorynotPagelist`, q).then((res) => {
    //     console.log(res, "222222");
    //     if (res && res.data) {
    //       let ll = res.data;
    //       let dropList = [];
    //       for (let index = 0; index < ll.length; index++) {
    //         const element = ll[index];
    //         let xx = {};
    //         xx.value = element.category_id;
    //         xx.name = element.name;
    //         xx.children = element.children || [];
    //         dropList.push(xx);
    //       }
    //       for (let index = 0; index < this.items.length; index++) {
    //         const element = this.items[index];
    //         if (element && element.name == "category_id") {
    //           this.items[index]["dropList"] = (
    //             element["dropList"] || []
    //           ).concat(dropList);
    //         }
    //       }
    //       console.log("dropList category_id", dropList);
    //     }
    //   });
    // },
    // gettagsDrop() {
    //   let q = {};
    //   $utils.api.load(`UserTagnotPagelist`, q).then((res) => {
    //     console.log(res, "222222");
    //     if (res && res.data) {
    //       let ll = res.data;
    //       let dropList = [];
    //       for (let index = 0; index < ll.length; index++) {
    //         const element = ll[index];
    //         let xx = {};
    //         xx.value = element.id.toString();
    //         xx.name = element.name;
    //         xx.children = element.children || [];
    //         dropList.push(xx);
    //       }
    //       for (let index = 0; index < this.items.length; index++) {
    //         const element = this.items[index];
    //         if (element && element.name == "tag_ids") {
    //           this.items[index]["dropList"] = (
    //             element["dropList"] || []
    //           ).concat(dropList);
    //         }
    //       }
    //       console.log("dropList tag_ids", dropList);
    //     }
    //   });
    // },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      this.$refs.form.validate((valid) => {
        console.log("handleSubmit forms", valid, this.forms);
        if (valid) {
          // this.forms.tag_ids = (this.forms.tag_ids || []).join(",");
          $form.handleSubmit(this);
        }
      });
    },
  },
};
</script>
